import React from 'react';
import { useState, useEffect, useRef } from 'react';

import axios from 'axios';
/*!

-youll need to choose two random proucts to test with and create discount codes for them 

-When a code is entered check the cart for what products are in the cart. if there is only one product assign the discount to that product, if there are multiple products assign the discount to the product with the lowest price.

https://shopify.dev/docs/api/ajax/reference/cart

Something like this:
('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          discount: discountCode
        }
      })
    })

-If the discount code is not valid, display an error message

-If the discount code is valid, display a success message and hide the input. 

*/

const getCart = () => {
  axios
    .get('/cart.json')
    .then((response) => {
      console.log('CART', response.data);
    })
    .catch((error) => {
      console.log('ERROR', error);
    });
};

const DiscountSelector = () => {
  const discountCode = useRef(null);

  useEffect(() => {
    getCart();
  }, []);
  return (
    <div>
      <h1>Discount Selector</h1>
      <label htmlFor="discountCode">DiscountCode</label>
      <input type="text" id="discountCode" />
      <button>Add</button>
    </div>
  );
};

export default DiscountSelector;
